



export default {
    name: "HeaderPrimary",
    props: ['textValue']
}
